import { useQuery } from '@tanstack/react-query';
import type { DeletionImpact, DeletionImpactRequest } from '@overlayqa/shared';
import { useAuth } from '../lib/auth';
import { deletionImpactApi } from '../lib/api/deletionImpact';

export function useDeletionImpact(request: DeletionImpactRequest | null, enabled: boolean) {
  const { getToken, isSignedIn } = useAuth();
  return useQuery<DeletionImpact, Error>({
    queryKey: ['deletion-impact', request?.kind ?? null, request?.ids.join(',') ?? null],
    queryFn: async () => deletionImpactApi.preview((await getToken()) ?? undefined, request as DeletionImpactRequest),
    enabled: enabled && request !== null && Boolean(isSignedIn),
    retry: false,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
  });
}
